import {gql, useLazyQuery} from '@apollo/client'
import paginationLimit from '../configs/paginationLimit.json'
import {useSelector} from 'react-redux'

export const GET_SAVED_PROSPECTS = gql`
  query GetSavedProspectsOrAttendees(
    $listName: String!
    $searchTerm: String
    $startIndex: Int!
    $limit: Int!
    $azureRole: String
    $sortColumn: String
    $sortDirection: String
  ) {
    savedProspectsOrAttendees(
      listName: $listName
      searchTerm: $searchTerm
      startIndex: $startIndex
      limit: $limit
      azureRole: $azureRole
      sortColumn: $sortColumn
      sortDirection: $sortDirection
    ) {
      totalCount
      listEventDescription
      prospects {
        fullName
        lastContactDate
        prospectType
        interestTag
        likelihoodToGive
        boardMember
        city
        contactReport
        uniqueConstituentIdentifier
        givingCapacity
        isManaged
        state
        educationSummary {
          classYear
          degreeCollegeMapping {
            college
            degree
          }
        }
      }
    }
  }
`

export default function useSavedConstituents() {
  const currentPage = useSelector((state) => state.currentPageNumber.allConstituentsSavedProspectsValue)
  const startIndex = (currentPage - 1) * paginationLimit.pagination.savedConstituentsList
  const {searchTerm} = useSelector((state) => state.openSavedProspect.setAllConstituentsfilters)
  const getListName = useSelector((state) => state.campaignAction)
  const azureRole = useSelector((state) => state.superUserTenantSlice.azureRole)
  const sortDirection = useSelector((state) => state.getAllProspectsData.sortDirection)
  const sortColumn = useSelector((state) => state.getAllProspectsData.sortColumn)
  const {name} = getListName
  const [conditionalSavedConstituents, {data, loading, error, refetch}] = useLazyQuery(GET_SAVED_PROSPECTS, {
    variables: {
      listName: name,
      searchTerm,
      startIndex,
      sortColumn,
      sortDirection,
      limit: paginationLimit.pagination.savedConstituentsList,
      ...(azureRole ? {azureRole} : {})
    },
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
    fetchPolicy: 'network-only'
  })
  return [conditionalSavedConstituents, {data, loading, error, refetch}]
}
